let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("8866c")).then(() => parcelRequire('4cp9X'));